<!-- 时间选择组件 -->
<template>
	<el-form-item :label="label_name">
		<el-col :span="24">
			<div class="block">
				<el-date-picker v-model="newTime" type="daterange" :picker-options="pickerOptions" value-format="timestamp"
				 range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" @change="change" align="right">
				</el-date-picker>
			</div>
		</el-col>
	</el-form-item>
</template>

<script>
	export default {
		name: 'Dtp',
		props: {
			label_name: {
				type: [String],
				required: false,
			},
			time: {
				type: String | Array,
				required: false,
			},
		},
		data() {
			return {
				// label_name:'时间选择:',
				newTime:this.time,
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date(new Date().toDateString()).getTime(); // 0点时间戳
							const start = end - 3600 * 1000 * 24 * 7;
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date(new Date().toDateString()).getTime(); // 0点时间戳
							const start = end - 3600 * 1000 * 24 * 30;
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date(new Date().toDateString()).getTime(); // 0点时间戳
							const start = end - 3600 * 1000 * 24 * 90;
							picker.$emit('pick', [start, end]);
						}
					}]
				},
			}
		},
		watch:{
			time(){ // 监听变化
				this.newTime = this.time
			}
		},
		methods: {
			//用户确认选定的值时触发
			change() {
				this.$emit('getTime', this.newTime);
			}
		}
	}
</script>

<style>
</style>
